import { Box, Typography } from "@mui/material";
import { BodyStyle, ContentStyle, LegendContainerStyle, boxStyle, boxWrapperStyle } from "./styled";

interface ILegendProps {
  isCasual: boolean,
  handleClick: () => void
}

export const Legend: React.FC<ILegendProps> = ({ isCasual, handleClick }) => (
  <Box sx={LegendContainerStyle} onClick={handleClick} data-automation="legend">
    <Box sx={BodyStyle}>
      <Typography sx={{ fontWeight: 'bold', pb: 1 }} data-automation="legend-title">Legend:</Typography>
      <Box sx={ContentStyle}>
        <Box sx={boxWrapperStyle} data-automation="legend-keys">
          <Box sx={(theme) => ({ ...boxStyle(theme), background: "#FFCC33" })}>
            <Box
              component={'img'}
              sx={{ width: '100%' }}
              src="../../../assets/images/cross_alpha_small.png"
            />
          </Box>
          <Typography>Employee did not use the DOA and dispatched</Typography>
        </Box>
        <Box sx={boxWrapperStyle} data-automation="legend-keys">
          <Box sx={(theme) => ({ ...boxStyle(theme), background: "#CCFFCC" })}>
            {isCasual &&
              <Box
                component={'img'}
                sx={{ width: '100%' }}
                src="../../../assets/images/cross_alpha_small.png"
              />
            }
          </Box>
          <Typography>
            {isCasual ? 'Employee used the DOA and not plugged in' : 'Employee used the DOA and not dispatched'}
          </Typography>
        </Box>
        <Box sx={boxWrapperStyle} data-automation="legend-keys">
          <Box sx={(theme) => ({ ...boxStyle(theme), background: "#ffffff" })}>
            <Box
              component={'img'}
              sx={{ width: '100%' }}
              src="../../../assets/images/tick_alpha_small_2.png"
            />
          </Box>
          <Typography>Employee used the DOA and dispatched</Typography>
        </Box>
        {isCasual &&
          <Box sx={boxWrapperStyle} data-automation="legend-keys">
            <Box sx={(theme) => ({ ...boxStyle(theme), background: "#FFFF99" })} />
            <Typography>Employee used the DOA, plugged in but not dispatched</Typography>
          </Box>
        }
        <Box sx={boxWrapperStyle} data-automation="legend-keys">
          <Box sx={(theme) => ({ ...boxStyle(theme), border: '3px solid #6600CC', background: "#ffffff" })} />
          <Typography>Jobs ordered after DOA expiry time frame</Typography>
        </Box>
        <Box sx={boxWrapperStyle} data-automation="legend-keys">
          <Box sx={(theme) => ({ ...boxStyle(theme), background: "#AAAAAA" })} />
          <Typography>Employee not eligible to work shift</Typography>
        </Box>
      </Box>
    </Box>
  </Box >
);
